/**
 * Textos de Existencias (`es`) — modelo Lote + Lugar (OBR-142: OBR-143, OBR-146, OBR-14): junta los ficheros de cada tramo.
 * Enchufado a `es.ts` con un solo `...existenciesEs`; así cada tramo edita solo su fichero.
 */

import { statesEs } from './states.es.js';
import { stockLineEs } from './stockLine.es.js';
import { plantaStockEs } from './plantaStock.es.js';
import { viewsEs } from './views.es.js';
import { reprintEs } from './reprint.es.js';
import { countEs } from './count.es.js';
import { fefoEs } from './fefo.es.js';
import { receptionDirectEs } from './receptionDirect.es.js';
import { plantaCountEs } from './plantaCount.es.js';

export const existenciesEs = {
  ...statesEs,
  ...stockLineEs,
  ...plantaStockEs,
  ...viewsEs,
  ...reprintEs,
  ...countEs,
  ...fefoEs,
  ...receptionDirectEs,
  ...plantaCountEs,
} as const;
